import axiosInstance from ".";

export const getApplications = () => {
  return axiosInstance.get("/applications");
};

export const addApplications= (data) => {
  return axiosInstance.post("/applications", data);
};

export const updateApplications= (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/applications/${id}`, payload);
};

